<mat-toolbar class="footer" color="primary">
  <div>
    © 2024 {{'Footer.CopyRight' | translate }} <a (click)="openPrivacy()">{{'Footer.Privacy' | translate}}</a><span>|</span>
    <a (click)="openTermOfUse()" >{{'Footer.TermofUse' | translate}}</a><span *ngIf="userType === usertypeEnum.Member ">|</span>
    <a (click)="openContact()" *ngIf="userType === usertypeEnum.Member ">{{'Footer.Contact' | translate}}</a></div>
  <div class="logo-section">{{'Footer.PoweredBy' | translate }} <img src= "../../../assets/images/eckler-logo-reversed.svg" /></div>
</mat-toolbar>